import { render, staticRenderFns } from "./tablePageComp.vue?vue&type=template&id=33321e6a&scoped=true"
import script from "./tablePageComp.vue?vue&type=script&lang=js"
export * from "./tablePageComp.vue?vue&type=script&lang=js"
import style1 from "./tablePageComp.vue?vue&type=style&index=1&id=33321e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33321e6a",
  null
  
)

export default component.exports